import { formatPayPaymentMethodLabel } from './paymentMethodLabel';
import type { Option } from '@magicdoorinc/ui';
import type { PaymentMethodPurpose, PaymentMethodDto } from '~/swagger/pay/Api';
import type { PaymentAccountDto } from '~/swagger/portal/Api';

/**
 * Portal: 从 PaymentAccountDto[] 筛选 ACH（plaid）并转为 Option[]
 */
export function portalPaymentAccountsToOptions(accounts: PaymentAccountDto[]): Option[] {
  return (accounts ?? []).filter((a) => !!a.plaid).map((a) => ({ label: a.name, value: a.id }));
}

/**
 * Pay: 过滤未停用的 PaymentMethodDto[]
 */
export function filterActivePaymentMethods(items: PaymentMethodDto[]): PaymentMethodDto[] {
  return (items ?? []).filter((m) => !m.isDeactivated);
}

/**
 * Pay: 从 PaymentMethodDto[] 转为 Option[]
 * @param options.purpose - 不传则仅过滤 !isDeactivated；传则额外筛选 capabilities 包含该 purpose
 */
export function payPaymentMethodsToOptions(items: PaymentMethodDto[], options?: { purpose?: PaymentMethodPurpose }): Option[] {
  const filtered = filterActivePaymentMethods(items ?? []);
  const byPurpose = options?.purpose ? filtered.filter((m) => m.capabilities?.includes(options.purpose!)) : filtered;
  return byPurpose.map((m) => ({
    label: formatPayPaymentMethodLabel(m),
    value: m.id,
  }));
}
